import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class AuthService {

  public static AUTH_URL = 'http://localhost:3000/auth/google';

  public userId = 1;

  constructor(public router: Router, public http: HttpClient) { }

  public isAuthenticated(): Observable<boolean> {
    return Observable.create(observer => {
      if (this.isLoggedIn) {
        observer.next(true);
      } else {
        this.router.navigate(['/login']);
        observer.next(false);
      }
    });
  }

  get isLoggedIn(): boolean {
    return true;
  }

  login(): Observable<any> {
    return this.http.get(AuthService.AUTH_URL);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts